// Shared inline-style language for the Aduanall apps. Extracted so a style fix
// lands in one place. The cotejo app extends it with its own palette (rails,
// channel, expediente) — see plans/document-comparison.md "Extensión de paleta".

export const styles = {
  page: { display: 'flex', justifyContent: 'center', padding: '24px' },
  card: {
    width: '100%',
    maxWidth: '1100px',
    backgroundColor: '#fff',
    borderRadius: '8px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    overflow: 'hidden',
  },
  header: { padding: '16px 20px', borderBottom: '1px solid #e5e5e5' },
  title: { margin: 0, fontSize: '20px', fontWeight: '600', color: '#222' },
  body: { padding: '20px' },
  text: { marginBottom: '16px', fontSize: '14px', color: '#444' },
  section: { marginBottom: '20px' },
  label: {
    display: 'block',
    fontWeight: '600',
    fontSize: '13px',
    marginBottom: '8px',
    color: '#666',
  },
  divider: { border: '0', borderTop: '1px solid #eee', margin: '20px 0' },
  centerBox: { textAlign: 'center' },
  warningBox: {
    backgroundColor: '#fff3cd',
    color: '#8a6d3b',
    border: '1px solid #ffe69c',
    borderRadius: '6px',
    padding: '10px 14px',
    fontSize: '13px',
    lineHeight: 1.4,
    textAlign: 'left',
    marginBottom: '12px',
  },
  buttonsRow: {
    display: 'flex',
    gap: '12px',
    justifyContent: 'center',
    marginTop: '12px',
    flexWrap: 'wrap',
  },
  button: {
    padding: '8px 16px',
    borderRadius: '4px',
    border: 'none',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '500',
  },
  buttonDanger: { backgroundColor: '#e53935', color: '#ffffff' },
  buttonSuccess: { backgroundColor: '#43a047', color: '#ffffff' },
  buttonInfo: { backgroundColor: '#039be5', color: '#ffffff' },
  buttonGhost: {
    backgroundColor: 'transparent',
    color: '#039be5',
    border: '1px solid #039be5',
  },
  headerRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '16px 20px',
    borderBottom: '1px solid #e5e5e5',
  },
  tabsRow: {
    display: 'flex',
    gap: '4px',
    padding: '12px 20px 0',
    borderBottom: '1px solid #e5e5e5',
  },
  tab: {
    padding: '8px 16px',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: 500,
    color: '#666',
    border: 'none',
    background: 'transparent',
    borderBottom: '3px solid transparent',
    marginBottom: '-1px',
  },
  tabActive: { color: '#039be5', borderBottom: '3px solid #039be5' },
  table: { width: '100%', borderCollapse: 'collapse', fontSize: '13px' },
  th: {
    textAlign: 'left',
    padding: '8px 10px',
    borderBottom: '2px solid #e5e5e5',
    color: '#666',
    fontWeight: 600,
  },
  td: {
    padding: '8px 10px',
    borderBottom: '1px solid #f0f0f0',
    color: '#333',
  },
  badge: {
    display: 'inline-block',
    padding: '2px 8px',
    borderRadius: '10px',
    fontSize: '11px',
    fontWeight: 600,
  },
  badgePen: { backgroundColor: '#fff3cd', color: '#8a6d3b' },
  badgePro: { backgroundColor: '#d1ecf1', color: '#0c5460' },
  badgeCom: { backgroundColor: '#d4edda', color: '#155724' },
  badgeFai: { backgroundColor: '#f8d7da', color: '#721c24' },
  emptyHistorial: {
    padding: '40px 20px',
    textAlign: 'center',
    color: '#888',
    fontSize: '14px',
  },
  progressBarContainer: {
    width: '100%',
    backgroundColor: '#e0e0e0',
    borderRadius: '8px',
    height: '12px',
    margin: '8px 0',
    overflow: 'hidden',
  },
  progressBarFiller: {
    height: '100%',
    backgroundColor: '#43a047',
    transition: 'width 0.5s ease-in-out',
  },
  spinner: {
    border: '4px solid rgba(0, 0, 0, 0.1)',
    width: '36px',
    height: '36px',
    borderRadius: '50%',
    borderLeftColor: '#039be5',
    animation: 'spin 1s linear infinite',
    display: 'inline-block',
  },
};

export const spinnerAnim = `
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

// Cotejo palette (from the customs-clearance world, not a generic palette).
export const cotejoColors = {
  railAlta: '#e53935', // rojo del semáforo fiscal
  railMedia: '#f9a825', // marcatextos
  railLectura: '#7e57c2', // tinta violeta del acuse
  gutterOk: '#43a047',
  expediente: '#faf8f3', // folder manila
};

export const formatFecha = (iso) => {
  if (!iso) return '';
  try {
    const d = new Date(iso);
    const fecha = d.toLocaleDateString('sv-SE', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    });
    const hora = d.toLocaleTimeString('es-MX', {
      hour: '2-digit',
      minute: '2-digit',
    });
    return `${fecha} ${hora}`;
  } catch {
    return iso;
  }
};
